import React from 'react';
import Footer from '../Shared/Footer/Footer';

const AboutUs = () => {
    return (
        <div>
            Hello World
            <Footer></Footer>
        </div>
    );
};

export default AboutUs;